import { memo, useMemo } from 'react';
import useIsMobile from '../../utils/isMobile';
import { feedbackActions, selectFeedbackStatus } from '../../store/slices/feedback';
import { useAppDispatch, useAppSelector } from '../../store/store';

import '../../styles/Feedback.scss';

type FeedbackButtonProps = {
  footerHeight: number | null;
};

export const FeedbackButton = memo(({ footerHeight }: FeedbackButtonProps) => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectFeedbackStatus);
  const isMobile = useIsMobile();

  const offsets = useMemo(() => {
    const base = footerHeight ?? 0;
    const bottom = Math.max(isMobile ? 16 : 24, base + (isMobile ? 12 : 16));
    const right = isMobile ? 16 : 24;
    return { bottom, right };
  }, [footerHeight, isMobile]);

  const button = (
    <button
      type='button'
      className='feedback-floating-button'
      aria-label='Open feedback and ideas form'
      onClick={() => dispatch(feedbackActions.openModal())}
      disabled={status === 'submitting'}
    >
      <span className='feedback-floating-button__icon' aria-hidden>
        <svg viewBox='0 0 24 24' role='presentation' width='18' height='18' fill='currentColor'>
          <path d='M4 4.75C4 3.784 4.784 3 5.75 3h12.5C19.216 3 20 3.784 20 4.75v9.5c0 .966-.784 1.75-1.75 1.75H8.81l-3.28 3.28A.75.75 0 0 1 4 18.75zM5.75 4.5a.25.25 0 0 0-.25.25v12.69l2.47-2.47a.75.75 0 0 1 .53-.22h9.25a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25z' />
        </svg>
      </span>
      <span className='feedback-floating-button__label'>Feedback</span>
    </button>
  );

  return (
    <div
      className='feedback-floating-button-wrapper'
      style={{ bottom: offsets.bottom, right: offsets.right }}
    >
      {button}
    </div>
  );
});

FeedbackButton.displayName = 'FeedbackButton';
